// Theme primitives - kept tiny and dependency-free. We avoid `next-themes`
// to keep the client bundle slim and to control the no-flash inline script
// ourselves. Theme persists in a cookie + a localStorage mirror so SSR can
// pre-render with the right `.dark` class and the client never flickers.

export const THEME_COOKIE = "swift_theme";
export const THEME_VALUES = ["light", "dark", "system"] as const;
export type ThemeValue = (typeof THEME_VALUES)[number];

export function isThemeValue(v: unknown): v is ThemeValue {
  return typeof v === "string" && (THEME_VALUES as readonly string[]).includes(v);
}

// Server-side helper: read the user's preference from cookies. Layout reads
// this so the initial server render attaches `.dark` (or not) before any JS
// runs - no FOUC.
export function readThemeCookie(rawCookieHeader: string | undefined): ThemeValue {
  if (!rawCookieHeader) return "system";
  const match = rawCookieHeader
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${THEME_COOKIE}=`));
  if (!match) return "system";
  const value = decodeURIComponent(match.slice(THEME_COOKIE.length + 1));
  return isThemeValue(value) ? value : "system";
}
